import React, { useEffect, useRef } from "react";
import axios from "axios";
import { Alert } from "@opendate-app/setlist";

import { toastError } from "../../../shared/toastHelper";

const detailsStyle = {
  display: "grid",
  gridTemplateColumns: "max-content 1fr",
  gap: "4px 16px",
  fontSize: 14,
  lineHeight: "20px",
  color: "var(--sl-text-primary)",
};

const labelStyle = {
  fontWeight: 600,
  color: "var(--sl-text-secondary)",
};

const viewerStyle = {
  height: "60vh",
  marginTop: 16,
  border: "1px solid var(--sl-border-secondary)",
  borderRadius: 8,
  overflow: "hidden",
  background: "#fff",
};

const frameStyle = {
  border: "none",
  width: "100%",
  height: "100%",
};

const LOADING_DOCUMENT = `
  <html>
    <head>
      <style>
        body { display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; }
      </style>
    </head>
    <body>
      <img src="/uploading-loading.gif" width="50px" alt="Loading..." />
    </body>
  </html>`;

const AhoyMessageShow = ({
  csrfToken,
  team,
  ahoyMessage,
}) => {
  const iframeRef = useRef(null);

  const updateLinks = () => {
    const iframe = iframeRef.current;

    if (iframe && iframe.contentDocument) {
      iframe.contentDocument.querySelectorAll("a").forEach((link) => {
        link.setAttribute("target", "_blank");
      });
    }
  };

  const fetchAhoyMessage = (id) => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;

    axios.get(`/teams/${team.id}/ahoy_messages/${id}.json`)
      .then((response) => {
        iframeRef.current.srcdoc = response.data.email.html_body;
      })
      .catch(() => {
        toastError("Could not load email. Please try again.");
      });
  };

  useEffect(() => {
    if (iframeRef.current && !ahoyMessage.email?.html_body) {
      fetchAhoyMessage(ahoyMessage.id);
    }
  }, [iframeRef]);

  const recipientAddress = ahoyMessage.email?.to || ahoyMessage.to || ahoyMessage.user?.email;
  const timestamps = ahoyMessage.human_timestamps || {};
  const details = [
    ["From", ahoyMessage.email?.from],
    ["To", [ahoyMessage.user?.name, recipientAddress && `<${recipientAddress}>`].filter(Boolean).join(" ")],
    ["Subject", ahoyMessage.email?.subject],
    ["Sent at", timestamps.sent_at],
    ["Opened at", timestamps.opened_at],
    ["Clicked at", timestamps.clicked_at],
    ["Failed at", timestamps.failed_at],
  ].filter(([, value]) => value);

  return (
    <div>
      {ahoyMessage.failure_reasons.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <Alert
            color="error"
            role="alert"
            title="This delivery failed to send"
            description={ahoyMessage.failure_reasons.map((reason, index) => (
              <span key={index} style={{ display: "block" }}>{reason}</span>
            ))}
          />
        </div>
      )}
      <dl style={{ ...detailsStyle, margin: 0 }}>
        {details.map(([label, value]) => (
          <React.Fragment key={label}>
            <dt style={labelStyle}>{label}</dt>
            <dd style={{ margin: 0 }}>{value}</dd>
          </React.Fragment>
        ))}
      </dl>
      <div style={viewerStyle}>
        <iframe
          ref={iframeRef}
          title="Email preview"
          style={frameStyle}
          onLoad={updateLinks}
          srcDoc={ahoyMessage.email?.html_body || LOADING_DOCUMENT}
        />
      </div>
    </div>
  );
};

export default AhoyMessageShow;
